import type { ElementType } from 'react';
import {
  Phone,
  Calendar as CalendarIcon,
  Mail,
  FileText,
  ArrowRight,
  UserPlus,
} from 'lucide-react';
import { useActivities } from '../../../../hooks/useActivities';
import { Skeleton, EmptyState } from '../../../../ui';
import type { ActivityType } from '../../../../services/activities.service';

const ICON: Record<ActivityType, ElementType> = {
  CALL: Phone,
  MEETING: CalendarIcon,
  EMAIL: Mail,
  NOTE: FileText,
  STAGE_CHANGE: ArrowRight,
  ASSIGNMENT: UserPlus,
};

export function ActivityTab({ leadId }: { leadId: number }) {
  const { data, isLoading } = useActivities(leadId);

  if (isLoading) {
    return <Skeleton height={120} />;
  }
  if (!data || data.length === 0) {
    return (
      <EmptyState
        title="Sem atividades"
        body="Registre uma ligação, reunião ou email para construir o histórico deste lead."
      />
    );
  }

  return (
    <ol className="flex flex-col gap-3">
      {data.map((a) => {
        const Icon = ICON[a.type] ?? FileText;
        return (
          <li key={a.id} className="flex gap-3">
            <div className="rounded-full bg-subtle w-8 h-8 flex items-center justify-center shrink-0">
              <Icon className="w-4 h-4 text-ink-secondary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-ink-primary">{a.title}</p>
              {a.body && <p className="text-sm text-ink-secondary mt-0.5">{a.body}</p>}
              <p className="text-xs text-ink-tertiary mt-1">
                {new Date(a.occurredAt).toLocaleString('pt-BR')}
                {a.user && ` · ${a.user.name}`}
              </p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
